/** Seta uma função de redirect do React Router */
export default function setRedirectFunction(fn) {
  return {
    type: "REDIRECT_FN_SET",
    redirect: fn
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/redirect.js